import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { Eyebrow, RoleBody } from './styled';
import { DetailModal, TonePill } from '../../components';

export default function RoleModal({ section, roles, onClose }) {
  return (
    <DetailModal title={section.group} subtitle="Access by role" width={460} onClose={onClose}>
      <RoleBody>
        <ul className="rb-roles">
          {roles.map((r) => {
            const a = section.access[r.key];
            return (
              <li key={r.key}>
                <div>
                  <strong>{r.label}</strong>
                  <small>
                    {a.granted} of {a.total} capabilities{r.hint ? ` · ${r.hint}` : ''}
                  </small>
                </div>
                <TonePill $tone={a.tone}>{a.label}</TonePill>
              </li>
            );
          })}
        </ul>
        <div className="rb-caps">
          <Eyebrow>Capabilities in this section</Eyebrow>
          <ul>
            {section.items.map((p) => (
              <li key={p.key}>
                <FontAwesomeIcon icon={faCircleCheck} style={{ fontSize: 10, color: '#8c8c8c' }} />
                {p.label}
              </li>
            ))}
          </ul>
        </div>
      </RoleBody>
    </DetailModal>
  );
}
